export default __webpack_public_path__ + "static/media/icon-chevron.296cadde.svg";